import { render } from "./UiTablePlaceholder.vue?vue&type=template&id=4cc755c6"
import script from "./UiTablePlaceholder.vue?vue&type=script&lang=js"
export * from "./UiTablePlaceholder.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\merk\\Documents\\_kwork\\virginia79\\lk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__